// extracted by mini-css-extract-plugin
export var productType = "CardTag-module--productType--ade49";
export var productTypeExpedition = "CardTag-module--product-type-expedition--44bee";
export var smallVariant = "CardTag-module--small-variant--b9321";
export var tag = "CardTag-module--tag--aca04";
export var upperCase = "CardTag-module--upper-case--e9101";
export var white = "CardTag-module--white--2fb7b";